import React, { useEffect, useMemo } from 'react';
import { Slider, CnTextEllipsis } from '@alife/cn-ui';
import { logCustom } from 'src/utils/tracker';
import './index.scss';
export default (props) => {
    const { data, panelCode, list } = props;
    useEffect(() => {
        logCustom('EXP_self-tools', data?.questionnaireUrl, panelCode);
    }, []);
    const sliderList = useMemo(() => {
        const nodeList = [];
        list.forEach((item, i) => {
            let index = Math.floor(i / 4);
            if (i % 4 === 0) {
                nodeList[index] = [];
            }
            nodeList[index].push(item);
        });
        return nodeList.map((item, i) => {
            return (React.createElement("div", { className: 'cn-ui-intelli-assistant-panel-self-tool', key: i }, item.map((tempItem) => {
                return (React.createElement("div", { className: 'cn-ui-intelli-assistant-panel-self-tool-item', key: tempItem.functionName + (tempItem.language || ''), onClick: () => {
                        window.open(tempItem.url);
                        logCustom('CLK_self-tools', tempItem.url, panelCode);
                    } },
                    React.createElement("img", { src: tempItem.icon.url }),
                    React.createElement("div", { className: 'cn-ui-intelli-assistant-panel-self-tool-item-desc' },
                        React.createElement(CnTextEllipsis, null, tempItem.functionName))));
            })));
        });
    }, [list]);
    return (React.createElement(Slider, { className: 'cn-intelli-assistant-self-tool', arrows: false }, sliderList));
};
